import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import React from 'react';
import styles from './DENTMultipleSelectListItemActions.module.scss';

interface Props {
	handleEdit: () => void;
	handleDelete: () => void;
}

const DENTMultipleSelectListItemActions = ({
	handleEdit,
	handleDelete,
}: Props) => {
	return (
		<div className={styles.wrapper}>
			<LinkButton
				title={'base.shared.edit'}
				theme={Theme.BLUE}
				onClick={handleEdit}
			/>
			<LinkButton
				title={'base.shared.delete'}
				theme={Theme.RED}
				onClick={handleDelete}
			/>
		</div>
	);
};

export default DENTMultipleSelectListItemActions;
